import React, { useState } from "react";
import { Tile } from "./generic/Tile";
import { ConfirmDeleteModal } from "./generic/DeleteConfirmationModal";
import { ChooseIngredientsModal } from "./ChooseIngredientsModal";

export const Recipe = ({
  recipe: { ingredients },
  recipe,
  addProduct,
  onDelete,
  products,
  loading,
  setRecipeToEdit,
}) => {
  const productsToAdd =
    ingredients?.filter(
      (name) => !products.some((product) => product.name === name),
    ) || [];

  const alreadyOnList = !productsToAdd.length && ingredients?.length;

  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [chooseIngredientsOpen, setChooseIngredientsOpen] = useState(false);

  return (
    <>
      <Tile
        style={{
          backgroundColor: alreadyOnList ? "lightgreen" : "blanchedalmond",
          padding: 0,
          minHeight: "80px",
        }}
      >
        <div
          style={{
            overflowWrap: "break-word",
            maxWidth: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div style={{ padding: "0.375rem" }}>{recipe.name}</div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
            }}
          >
            <button
              style={{ fontSize: "1.25rem" }}
              onClick={() => setRecipeToEdit(recipe)}
            >
              ✏️
            </button>
            <button
              style={{ fontSize: "1.25rem" }}
              onClick={() => {
                setChooseIngredientsOpen(true);
                // productsToAdd.forEach((p) => addProduct({ name: p }));
              }}
              disabled={!productsToAdd.length}
            >
              🛒
            </button>
            <button
              style={{ fontSize: "1.25rem" }}
              onClick={() => setConfirmDeleteOpen(true)}
            >
              🚮
            </button>
          </div>
        </div>

        {confirmDeleteOpen && (
          <ConfirmDeleteModal
            recordName={`Rezept ${recipe.name}`}
            onClose={() => setConfirmDeleteOpen(false)}
            onSubmit={async () => {
              await onDelete(recipe.id);
              setConfirmDeleteOpen(false);
            }}
            loading={loading}
          />
        )}

        {chooseIngredientsOpen ? (
          <ChooseIngredientsModal
            ingredients={ingredients}
            onClose={() => setChooseIngredientsOpen(false)}
            addProduct={addProduct}
          />
        ) : null}
      </Tile>
    </>
  );
};
